import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 48px;
  padding-right: 24px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Status = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Viagem = styled(Status)``;

export const Lote = styled(Status)``;
